import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import CommonModal from '../Common/Modal/Modal';
import RadioGroup from '../FormInputs/RadioGroup/RadioGroup';

const ExportSeasonModal = ({
  seasons, onCloseModal, onCheck, handleSeasonExport,
}) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const handleSetValue = (value) => {
    onCheck(value);
    setIsDisabled(!value);
  };
  return (
    <CommonModal
      boxClassName="w-5/12 md:w-4/12 md:min-w-[656px]"
      title="Export Seasons"
      handleClose={onCloseModal}
      className=""
      shadow="shadow-vamos-drop-shadow"
      textAlignment="text-left"
      titlePosition="left"
      closeIconPosition=""
      headerClassName="p-5.5"
      maxHeight=""
      childrenStyle="pb-5.25"
      overflowY=""
      childrenHeight=""
    >
      <div className="pt-6.5 px-7 pb-14 overflow-y-auto max-h-[65vh]">
        <RadioGroup
          options={seasons}
          radioGroupLabel="Which season would you like to export?"
          sectionClassName="mx-4"
          setValue={handleSetValue}
        />
      </div>
      <div className="mx-5.25 justify-items-end">
        <Button
          label="Export"
          variant="primary"
          size="md"
          onClick={handleSeasonExport}
          isDisabled={isDisabled}
        />
      </div>
    </CommonModal>
  );
};

ExportSeasonModal.propTypes = {
  seasons: PropTypes.array.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onCheck: PropTypes.func.isRequired,
  handleSeasonExport: PropTypes.func.isRequired,
};

export default ExportSeasonModal;
